// ============================================================
// DATE FORMAT HELPER
// src/dateUtils.js
// Shared dd-mm-yyyy display formatter. Storage/state stays ISO
// (YYYY-MM-DD) everywhere — this is for display-only render sites.
// ============================================================

export function fmtDMY(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return s;
  const [, y, mo, d] = m;
  return `${d}-${mo}-${y}`;
}
